export default "__VITE_ASSET__BS9GIzEh__"